module.exports = __webpack_public_path__ + "static/media/forewoman-under_construction.082a35c9.gif";